module.exports = __webpack_public_path__ + "img/basmala.94816f48.png";